<template>
  <div>
    <user-image :puntaje="puntaje" :img="imageUser"></user-image>
    <menu-vertical class="menu"></menu-vertical>
    <!-- <barra-herramientas /> -->
    <div class="background"></div>
    <div id="info" class="info animate__animated animate__zoomIn">
      <p class="info_texto">PROXIMAMENTE</p>

      <div class="loader">
        <div class="loader-inner pacman">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div>
        <router-link to="/cuestionario-cuaterniones">CONTINUAR </router-link>
      </div>
    </div>
  </div>
</template>
<script>
// import * as Three from "three";
// import { TWEEN } from "three/examples/jsm/libs/tween.module.min";
// import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import MenuVertical from "@/components/MenuVertical.vue";
// import { FontLoader } from "three/examples/jsm/loaders/FontLoader.js";
// import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry.js";
// import BarraHerramientas from "@/components/BarraHerramientas.vue";
import UserImage from "../../components/UserImage.vue";
export default {
  name: "DemostacionSistemaCoordenadas",
  components: {
    // BarraHerramientas,
    MenuVertical,
    UserImage,
  },
  data() {
    return {
      puntaje: 0,
      felicidades: false,
      cont: 1,
      sphereU: null,
      textMesh1: null,
      axisZ: null,
      axisZr: null,
      cylinderZ: null,
      group: null,
      siguiente: false,
      camera: null,
      scene: null,
      renderer: null,
      gridHelper: null,
      gridHelperZX: null,
      gridHelperYZ: null,
      anim: null,
      raycaster: null,
      points: [],
      sphere: null,
      textMesh: null,
      textMeshY: null,
      textMeshZ: null,
      axisXCoor: null,
      axisZCoor: null,
      axisYCoor: null,
      decodeToken: null,
      imageUser:
        "https://cdn.pixabay.com/photo/2018/04/18/18/56/user-3331256__340.png",
      logros: [],
    };
  },
  methods: {
    play() {
      const info = document.getElementById("info");
      info.classList.remove("animate__zoomIn");
      info.classList.add("animate__fadeOut");
      const background = document.querySelector(".background");

      background.style.display = "none";
      info.style.display = "none";
    },
    onWindowResize() {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();

      this.renderer.setSize(window.innerWidth, window.innerHeight);
    },

    profile() {
      this.decodeToken = this.$getDataProfile(
        localStorage.getItem("token")
      ).uid;

      var axios = require("axios");

      var config = {
        method: "get",
        url: `https://restserver-cg.onrender.com/api/usuarios/${this.decodeToken}`,
        headers: {},
      };

      axios(config)
        .then((response) => {
          console.log(response.data);
          this.imageUser = response.data.img;
          this.logros = response.data.logros;
          this.puntaje = response.data.puntaje;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    logro() {
      this.felicidades = true;
      if (this.logros.indexOf("DemostracionCuaterniones") != -1) {
        console.log("ya tiene este logro");
      } else {
        this.puntaje += 10;
        this.logros.push("DemostracionCuaterniones");
        fetch(`https://restserver-cg.onrender.com/api/usuarios/${this.decodeToken}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: `{"logros":${JSON.stringify(this.logros)},"puntaje":${
            this.puntaje
          }}`,
        })
          .then((response) => {
            console.log(response);
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
  },
  mounted() {
    this.profile();
    setTimeout(() => {
      this.siguiente = true;
    }, 1000);
  },
};
</script>
<style scoped>
#container {
  height: 100vh;
  width: 100vw;
  background: #fff;
}
.menu {
  position: absolute;
} /* Points of interest */
.point {
  position: absolute;
  top: 50%;
  left: 50%;

  --point-color: #513bed96;
}

.point .label {
  position: absolute;
  top: -20px;
  left: -20px;
  width: fit-content;
  padding: 0.1rem 0.5rem;
  height: 40px;
  border-radius: 5px;
  background-color: #00000077;
  color: #ffffff;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  border: 1px solid #ffffff77;
  text-align: center;
  line-height: 40px;
  font-weight: bold;
  transition: background-color 0.3s ease-out, transform 0.3s ease-out;
  will-change: background-color, transform;
  cursor: help;
  transform: scale(0);
}

.point.visible .label {
  transform: scale(1);
}

.point .label:hover {
  background-color: var(--point-color);
  /* border-color: var(--point-color); */
}

.point .label:hover + .text {
  opacity: 1;
  transform: translateY(0);
}

.point .text {
  position: absolute;
  top: 30px;
  left: calc(-100px - 1em);
  width: 200px;
  background-color: #00000084;
  color: #ffffff;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.4;
  font-size: 1rem;
  padding: 1em 1.4em;
  border-radius: 4px;
  box-shadow: -2px 0 0 0 var(--point-color), 2px 0 0 0 var(--point-color);
  opacity: 0;
  transform: translateY(-10px);
  transition: opacity 0.3s ease-out, transform 0.3s ease-out;
  will-change: opacity, transition;
  pointer-events: none;
}
.botonActividad {
  font-size: 1.2rem;
  width: var(--espacio);
  padding: 0.8rem 1rem;
  border-radius: 6px;
  font-family: "Exo 2", sans-serif;
  background: #ffc300;
  font-weight: bold;
  cursor: pointer;
  position: absolute;
  /* right: calc(40%-var(--espacio)); */
  right: 2rem;
  top: 30rem;
  padding: 1rem;
}
.felicidades {
  position: absolute;
  background: white;
  border-radius: 10px;
  width: 40%;
  height: fit-content;
  /* height: 50%; */
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  font-family: "Exo 2", sans-serif !important;
  color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.felicidades h2 {
  position: relative;
  font-weight: bold;
  font-size: 2rem;
  margin-bottom: 1rem;
  padding: 0.5rem;
  font-family: "Exo 2", sans-serif !important;
  color: black;
}
.felicidades p {
  color: black;
  /* font-weight: bold; */
  font-family: "Exo 2", sans-serif !important;
  font-size: 1rem;
  margin-bottom: 1rem;
  padding: 0 1.5rem;
}
.felicidades img {
  margin: 1rem;
  width: 35%;
}
.botonLogro {
  position: relative;

  font-size: 1.2rem;
  width: var(--espacio);
  padding: 0.8rem 1rem;
  border-radius: 6px;
  font-family: "Exo 2", sans-serif;
  background: #ffc300;
  font-weight: bold;
  cursor: pointer;
  padding: 1rem;
  margin: 1rem;
}
.menu {
  position: absolute;
}
.arrow {
  position: absolute;

  width: 3vmin;
  height: 3vmin;
  background: transparent;
  border-top: 1vmin solid white;
  border-right: 1vmin solid white;
  box-shadow: 0 0 0 lightgray;
  transition: all 200ms ease;
  margin: 0 4rem;
}
.left {
  left: 0;
  transform: translate3d(0, -50%, 0) rotate(-135deg);
}

.right {
  right: 0;
  transform: translate3d(0, -50%, 0) rotate(45deg);
}
.flechas {
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  bottom: 0;
  margin-bottom: 5rem;
  width: 15rem;
}
.arrow:hover {
  border-color: orange;
  box-shadow: 0.5vmin -0.5vmin 0 white;
}

.arrow:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-40%, -60%) rotate(45deg);
  width: 200%;
  height: 200%;
}
:root {
  --espacio: fit-content;
}
.felicidades a {
  font-size: 1.2rem;
  width: var(--espacio);
  padding: 0.8rem 1rem;
  border-radius: 6px;
  font-family: "Exo 2", sans-serif;
  background: #ffc300;
  font-weight: bold;
  cursor: pointer;
  padding: 1rem;
  margin: 1rem;
}
#container {
  height: 100vh;
  width: 100vw;
}
.info1,
.info2,
.info3,
.info4,
.info5,
.info6,
.info7,
.info8,
.info9 {
  display: none;
  position: absolute;
  background: #fff;
  width: 40%;
  right: 0;
  top: 5rem;
  padding: 1rem;
  border-end-start-radius: 5px;
  border-start-start-radius: 5px;
}

.info1 {
  display: block;
}
.info2,
.info5 {
  top: 12rem;
}
.info5,
.info8 {
  top: 15rem;
}
.final {
  display: none;
}
.info3,
.info6,
.info9,
.final {
  /* right: none;
  left: 0; */
  top: 22rem;
}
.info {
  position: absolute;
  width: fit-content;
  height: fit-content;
  right: 0;
  left: 0;
  bottom: -5rem;
  top: 0;
  margin: auto;
}
.info_texto span {
  font-size: 3rem;
  font-weight: bold;
}

h3 span {
  font-weight: bold;
}
.info_texto span:nth-child(1),
h3 span:nth-child(1) {
  color: red;
}
.info_texto span:nth-child(2),
h3 span:nth-child(2) {
  color: #00ff00;
}
.info_texto span:nth-child(3),
h3 span:nth-child(3) {
  color: #0000ff;
}
h2 {
  position: absolute;
  margin-top: 1rem;
  margin: auto;
  right: 0;
  left: 0;
  width: fit-content;
  font-size: 1.5rem;
  color: white;
  font-weight: bold;
  font-family: "Exo 2", sans-serif;
}
p {
  position: relative;
  font-size: 2rem;
  font-weight: 700;
  color: #fff;
  width: 65%;

  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  height: fit-content;
  font-family: "Roboto Mono", monospace !important;
  color: rgb(0, 255, 0);
}
.loader {
  position: relative;
  width: fit-content;
  margin: auto;
  right: 0;
  left: 0;
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 25%;
  max-width: 25%;
  height: 200px;
  align-items: center;
  justify-content: center;
}
.pacman {
  position: relative;
}
.pacman > div:nth-child(2) {
  -webkit-animation: pacman-balls 1s 1.99s infinite linear;
  animation: pacman-balls 1s 1.99s infinite linear;
}
.pacman > div:nth-child(3) {
  -webkit-animation: pacman-balls 1s 1.66s infinite linear;
  animation: pacman-balls 1s 1.66s infinite linear;
}
.pacman > div:nth-child(4) {
  -webkit-animation: pacman-balls 1s 1.33s infinite linear;
  animation: pacman-balls 1s 1.33s infinite linear;
}
.pacman > div:nth-child(5) {
  -webkit-animation: pacman-balls 1s 1s infinite linear;
  animation: pacman-balls 1s 1s infinite linear;
}
.pacman > div:first-of-type {
  width: 0px;
  height: 0px;
  border-right: 25px solid transparent;
  border-top: 25px solid yellow;
  border-left: 25px solid yellow;
  border-bottom: 25px solid yellow;
  border-radius: 25px;
  -webkit-animation: rotate_pacman_half_up 0.5s 1s infinite;
  animation: rotate_pacman_half_up 0.5s 1s infinite;
  position: relative;
  left: -30px;
  z-index: 100;
}
.pacman > div:nth-child(2) {
  width: 0px;
  height: 0px;
  border-right: 25px solid transparent;
  border-top: 25px solid yellow;
  border-left: 25px solid yellow;
  border-bottom: 25px solid yellow;
  border-radius: 25px;
  -webkit-animation: rotate_pacman_half_down 0.5s 1s infinite;
  animation: rotate_pacman_half_down 0.5s 1s infinite;
  margin-top: -50px;
  position: relative;
  left: -30px;
  z-index: 100;
}
.pacman > div:nth-child(3),
.pacman > div:nth-child(4),
.pacman > div:nth-child(5),
.pacman > div:nth-child(6) {
  background-color: red;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  width: 10px;
  height: 10px;
  position: absolute;
  -webkit-transform: translate(0, -6.25px);
  transform: translate(0, -6.25px);
  top: 25px;
  left: 70px;
}
.next {
  font-size: 4rem;
  color: white;
  transition-duration: 0.3s;
  cursor: pointer;
}
.next:hover {
  color: #00ff00;
  transform: scale(1.2);
}
.felicidades {
  position: absolute;
  background: white;
  border-radius: 10px;
  width: 40%;
  height: fit-content;
  /* height: 50%; */
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  font-family: "Exo 2", sans-serif !important;
  color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.felicidades h2 {
  position: relative;
  font-weight: bold;
  font-size: 2rem;
  margin-bottom: 1rem;
  padding: 0.5rem;
  font-family: "Exo 2", sans-serif !important;
  color: black;
}
.felicidades p {
  color: black;
  /* font-weight: bold; */
  font-family: "Exo 2", sans-serif !important;
  font-size: 1rem;
  margin-bottom: 1rem;
  padding: 0 1.5rem;
}
.felicidades img {
  margin: 1rem;
  width: 35%;
}
@-webkit-keyframes rotate_pacman_half_up {
  0% {
    -webkit-transform: rotate(270deg);
    transform: rotate(270deg);
  }
  50% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
  100% {
    -webkit-transform: rotate(270deg);
    transform: rotate(270deg);
  }
}

@keyframes rotate_pacman_half_up {
  0% {
    -webkit-transform: rotate(270deg);
    transform: rotate(270deg);
  }
  50% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
  100% {
    -webkit-transform: rotate(270deg);
    transform: rotate(270deg);
  }
}

@-webkit-keyframes rotate_pacman_half_down {
  0% {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }
  50% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }
}

@keyframes rotate_pacman_half_down {
  0% {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }
  50% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }
}

@-webkit-keyframes pacman-balls {
  75% {
    opacity: 0.7;
  }
  100% {
    -webkit-transform: translate(-100px, -6.25px);
    transform: translate(-100px, -6.25px);
  }
}

@keyframes pacman-balls {
  75% {
    opacity: 0.7;
  }
  100% {
    -webkit-transform: translate(-100px, -6.25px);
    transform: translate(-100px, -6.25px);
  }
}
.background {
  width: 100vw;
  height: 100vh;
  background: black;
}
</style>
